/* eslint-disable no-else-return */
import { useEffect, useCallback } from 'react';
import { useStore, useStoreApi } from '@tmsw/powerups.store';
import * as Tone from 'tone';
import { useReactAudioContext } from '@tmsw/powerups.audio.provider';

const audioNodes: any = [];

const volumeSelector = (state: any) => state.currentVolume;
const setVolumeSelector = (state: any) => state.setCurrentVolume;

export function useVolume() {
  const { getContext } = useReactAudioContext();
  const { subscribe } = useStoreApi();

  // console.log('useVolumeControl :: audioCtxStarted?', audioCtxStarted);

  const volume = useStore(volumeSelector);
  const setVolume = useStore(setVolumeSelector);

  const dynamicRange = 70;

  const calculateVolume = (val: number) => {
    return dynamicRange * (val / 100) - dynamicRange;
  };

  const connectAudioNode = (audioNode: any) => {
    const context = getContext();
    if (
      audioNode instanceof HTMLMediaElement &&
      !audioNodes.includes(audioNode)
    ) {
      audioNodes.push(audioNode);
      const mediaElement = context.createMediaElementSource(audioNode);
      // @ts-ignore
      const mediaGainNode = context.createGain({
        gain: 1,
        units: 'decibels',
      });
      mediaElement.connect(mediaGainNode);
      Tone.connect(mediaGainNode, context.destination);
      return mediaGainNode;
    } else if (
      audioNode.constructor.name === 'Players' ||
      audioNode.constructor.name === 'Player'
    ) {
      audioNode.connect(Tone.Destination);
    }
    return audioNode;
  };

  const updateVolume = useCallback(
    (value: number) => {
      // clamp value between 0 and 100
      value = Math.max(0, Math.min(value, 100));
      const vol = calculateVolume(value);
      console.log('Volume: ', value, vol);
      Tone.getContext().destination.volume.value = vol;
      Tone.getContext().destination.mute = vol < -60;
      if (volume !== value) setVolume(value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [volume]
  );

  // onMount :: sync volume from store
  useEffect(() => {
    updateVolume(volume);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // subscribe to volume changes and update AudioContext transiently 🤫
  useEffect(() => {
    const unsubVolumeChanged = subscribe(
      (state) => state.currentVolume,
      (curr) => updateVolume(curr)
    );
    return () => {
      unsubVolumeChanged();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribe]);

  return {
    connectAudioNode,
    updateVolume,
    volume,
    getContext: Tone.getContext,
  };
}
